import $ from "jquery";
import "jquery-ui-dist";
import { inject } from "aurelia-framework";
import { AuthService } from "../../services/authService";
import { Router } from "aurelia-router";
import { UserMessageService } from "../../services/userMessageService";
import { TestimonialFromAPI } from "../../services/testimonialFormAPI";
@inject(AuthService, Router, TestimonialFromAPI, UserMessageService)
export class TestimonialForm {
  constructor(authService, router, api, userMessageService) {
    this.authService = authService;
    this.router = router;
    this.api = api;
    this.userMessageService = userMessageService;
    this.whitelabel_id = null;
    this.saving = false;
    this.editable = true;
    this.loading = true;
    this.app_name = "Magnfi";
    this.file_name = null;
    this.code = null;
    this.concent=false;
    this.instructionsMax=250;
    if (window.whitelabel) {
      this.app_name = window.app_name;
    }

    this.subjectMax = 64;
    this.bodyMax = 250;
    this.ctaLinkMax = 500;
    this.ctaTextMax = 20;

    this.recipents = [
      {
        email: "",
        firstName: "",
        lastName: "",
        instructions:"",
        instructionsCharsLeft:250
      },
      {
        email: "",
        firstName: "",
        lastName: "",
        instructions:"",
        instructionsCharsLeft:250
      },
      {
        email: "",
        firstName: "",
        lastName: "",
        instructions:"",
        instructionsCharsLeft:250
      },
    ];
  }

  addRecipient() {
    this.recipents.push({
      email: "",
      firstName: "",
      lastName: "",
      instructions:"",
      instructionsCharsLeft:250

    });
  }

  submit() {
    if (this.isValidate()) {
      this.saving = true;
      this.api.submit(
        this.code,
        {recipents:this.recipents},
        this.saveLoadSuccess.bind(this),
        this.saveLoadError.bind(this)
      );
    }
  }

  isValidate() {

    let valid = true;
    this.recipents.forEach((recipent,index) => {

      if (
        recipent.email.trim() !== "" &&
        (recipent.firstName.trim() == "" ||
        recipent.lastName.trim() == "" ||
        recipent.instructions.trim() == "")
      ){

        this.userMessageService.setUserError(
          "user",
          "<p style='margin-left:10px;margin-top:5px;padding-right:10px;display:inline-block'>Recipent ("+recipent.email.trim() +") information </br>  cannot be empty<p>"
        );
        valid = false;
      }

    });
    if (!this.concent){
      this.userMessageService.setUserError(
        "user",
        "Please check the concent box"
      );
      return false
    }


    if(valid){
      this.recipents=this.recipents.filter((recipent,index) => {
        return recipent.email.trim() !== ""
      })

      if(!this.recipents.length){
    
        this.userMessageService.setUserError(
          "user",
          "<span style='margin-left:10px;margin-top:5px;padding-right:10px;display:inline-block'>Please add at least one  reciepent </br> information<span>"
        );
        valid = false;
      }

    }

    return valid;
  }
  activate(params, route) {
    this.code = params.code;
  }

  instructionsKeyUp(index) {
    var len = this.recipents[index].instructions.length;

    if (len > this.instructionsMax) {
        this.recipents[index].instructions = this.recipents[index].instructions.substring(0, this.instructionsMax);
    } else {
        this.recipents[index].instructionsCharsLeft = this.instructionsMax - len;
    }
}


  instructionsChanged(index) {
    if (this.recipents[index].topic != -1)
        this.recipents[index].instructions =this.recipents[index].topic;
    else
        this.instructions = "";

    this.instructionsKeyUp(index);

    // this.instructionsCtrl.focus();

}

  contacts_autocomplete(data) {
    $("#contacts_search").data().autocomplete = null;
    $("#contacts_search").autocomplete({
      source: data.contacts,
      minLength: 2,
      select: this.autofill.bind(this),
    });
  }

  handleKeypress(event) {}

  attached() {
    // this.userMessageService.setUserError("user", "fff")

    this.api.validateCode(
      this.code,
      () => {},
      (msg) => {
        setTimeout(() => {
          this.userMessageService.setUserError("user", msg);
        }, 500);

        setTimeout(() => {
          this.router.navigate("#/");
        }, 5000);
      }
    );
  }

  detached() {}

  reset() {
    this.recipents = [
      {
        email: "",
        firstName: "",
        lastName: "",
      },
      {
        email: "",
        firstName: "",
        lastName: "",
      },
      {
        email: "",
        firstName: "",
        lastName: "",
      },
    ];
  }

  saveLoadSuccess(data) {
    this.sending = false;
    this.saving = false;
    this.deleting = false;
    this.userMessageService.setUserMessage("user", "Testimonial Request submited!");
    setTimeout(() => {
      this.router.navigate("#/");
    }, 2000);
  }
  saveLoadError(msg) {
    this.sending = false;
    this.saving = false;
    this.deleting = false;
    this.userMessageService.setUserError("user", msg);
  }

  is_email(email) {
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailReg.test(email);
  }
}
